import React from 'react';

import Base from './components/base';

export default (props) => {
  return <Base {...props} />;
};
